import { gql } from '@apollo/client'

export const GET_SCHEDULE_AVAILABILITY = gql`
  query CoachAvailability {
    coachAvailabilities {
      coachFacility {
        id
        name
      }
      startDate
      timeZone
      timeSlots {
        day
        startTime
        endTime
      }
    }
  }
`

export const GET_SCHEDULE_BLOCK_TIMES = gql`
  query CoachAvailabilityBlockTimesForWeek($datetimeRange: DateTimeRangeInput) {
    coachAvailabilityBlockTimes(datetimeRange: $datetimeRange) {
      id
      startTime
      endTime
      allDay
      blockNote
      coachFacility {
        id
        name
      }
    }
  }
`
